import React from "react";

import { faAngleRight } from "@fortawesome/pro-regular-svg-icons/faAngleRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import zapierIllustration from "@app/assets/integrations/zapier-illustration.png";
import TextWithLine from "@app/component/typography/TextWithLine";

import { docusignPaleLogo, dropboxPaleLogo, quickbooksPaleLogo, zapierLogo } from "../../logo";

import styles from "./Zapier.module.scss";

const cloudServices: Record<string, string> = {
  docusign: docusignPaleLogo,
  dropbox: dropboxPaleLogo,
  quickbooks: quickbooksPaleLogo,
};

const GET_STARTED_LINK = "https://zapier.com/apps/map-my-customers/integrations";

export const ZapierBlock: React.FC = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <TextWithLine>
          {intl.formatMessage({
            id: "integrations.zappier.title",
            defaultMessage: "Build automations with thousands of apps",
            description: "Title of Zappier section",
          })}
        </TextWithLine>
      </div>
      <div className={styles.image}>
        <img alt="" src={zapierIllustration} />
      </div>
      <div className={styles.desc}>
        <img alt="" className={styles.logo} src={zapierLogo} />
        <div>
          {intl.formatMessage(
            {
              id: "integrations.zapier.text",
              defaultMessage:
                "Now connect <b>over 3000+</b> apps to Map My Customers with Zapier - the leading way to create automations and workflows between applications like:",
              description: "Text of Zapier section",
            },
            {
              b: (test) => <strong>{test}</strong>,
            }
          )}
        </div>
        <div className={styles.services}>
          {Object.entries(cloudServices).map(([name, logo]) => (
            <img alt="" key={name} src={logo} />
          ))}
        </div>
        <Button
          className={styles.link}
          href={GET_STARTED_LINK}
          rightIcon={<FontAwesomeIcon icon={faAngleRight} size="xs" />}
          target="_blank"
          type="link"
        >
          {intl.formatMessage({
            id: "integrations.zapier.title",
            defaultMessage: "Get started",
            description: "Title of Zapier section",
          })}
        </Button>
      </div>
    </div>
  );
};
export default ZapierBlock;
